import { useState } from 'react';
import "../style/AppPages.css"
import { Trans, useTranslation } from 'react-i18next';
import { homeImages, siliconePourGifUrl } from '../images/siteImages';
import { getSelectedLanguageOption } from '../i18n';

const  ChooseAwootoysSilicone = () => {
    const { t, i18n } = useTranslation();
    const currentLang = getSelectedLanguageOption(i18n.language).value;


    const [imagesLoaded, setImagesLoaded] = useState(0);

    const siliconeQualityDocumentUrl = homeImages[currentLang.toUpperCase()].siliconeQualityDocument;

    const handleImageLoad = () => {
    setImagesLoaded(prev => prev + 1);
    };
    
    return (
        <div class="page-padding-info">
            <div class="text-page-container awootoys-silicone-page-container">
                {/* <h1 class="text-page-title">{t("awootoysSilicone.title")}</h1> */}
                    
                    <div className="awootoys-silicone-image-container">
                        <img className="awootoys-silicone-pour-gif" src={siliconePourGifUrl} alt="Silicone Pour Gif" />
                        <img className="awootoys-silicone-document-image" src={siliconeQualityDocumentUrl} alt="Silicone Quality Document" onLoad={handleImageLoad} />
                    </div>

                    <p class="awootoys-silicone-text-content">  
                        &nbsp;
                        <Trans i18nKey="awootoysSilicone.chooseUsText1" components={{ 1: <strong /> }} />
                        <br></br>
                        <br></br>


                        <Trans i18nKey="awootoysSilicone.chooseUsText2Title" components={{ 1: <strong /> }} />
                        <Trans i18nKey="awootoysSilicone.chooseUsText2" components={{ 1: <strong /> }} />
                        <br></br>
                        <br></br>


                        <Trans i18nKey="awootoysSilicone.chooseUsText3Title" components={{ 1: <strong /> }} />
                        <Trans i18nKey="awootoysSilicone.chooseUsText3" components={{ 1: <strong /> }} />
                        <br></br>
                        <br></br>


                        <Trans i18nKey="awootoysSilicone.chooseUsText4Title" components={{ 1: <strong /> }} />
                        <Trans i18nKey="awootoysSilicone.chooseUsText4" components={{ 1: <strong /> }} />
                        <br></br>
                        <br></br>


                        <Trans i18nKey="awootoysSilicone.chooseUsText5Title" components={{ 1: <strong /> }} />
                        <Trans i18nKey="awootoysSilicone.chooseUsText5" components={{ 1: <strong /> }} />
                        <br></br>
                        <br></br>


                        <Trans i18nKey="awootoysSilicone.chooseUsText6Title" components={{ 1: <strong /> }} />
                        <Trans i18nKey="awootoysSilicone.chooseUsText6" components={{ 1: <strong /> }} />
                        <br></br>
                        <br></br>

                        &nbsp;
                        <Trans i18nKey="awootoysSilicone.chooseUsText7" components={{ 1: <strong /> }} />
                        <br></br>
                        <br></br>

                        &nbsp;
                        <Trans i18nKey="awootoysSilicone.chooseUsText8" components={{ 1: <a href="/softness-guide" class="no-link-color bold-text" /> }} />
                    </p>
            </div>
        </div>
    );
}

export default ChooseAwootoysSilicone;